import React, { SyntheticEvent } from 'react';
import { Grid, Input } from 'semantic-ui-react';
import { Field, FormikProps } from 'formik';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SectionLabel from '../../../../../../components/SectionLabel';
import { FieldLabel } from '../../../../../../styles';
import CustomDatePicker from '../../../../../../components/CustomDatePicker';
import AppMaskedInput from '../../../../../../components/MaskedInput';
import { DATE_INPUT_MASK } from '../../../../../../services/masks';
import { OtherProductClaimInitialValuesType } from '../../Formik/types';

const quillModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean']
  ]
};

/** Evita deslocamento de um dia ao parsear YYYY-MM-DD (UTC). */
const parseLocalDate = (value?: string | Date | null): Date | undefined => {
  if (!value) return undefined;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

const ClaimDetailsStep = ({
  values,
  setFieldValue
}: FormikProps<OtherProductClaimInitialValuesType>) => {
  return (
    <div>
      <SectionLabel text="Detalhes do evento" />
      <Grid>
        <Grid.Row>
          <Grid.Column width={4}>
            <FieldLabel>Data</FieldLabel>
            <Field
              name="claimEstate.eventDate"
              selected={parseLocalDate(values.claimEstate.eventDate as any)}
              component={CustomDatePicker}
              customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
              dateFormat="dd/MM/yyyy"
              onChange={(date: Date, _e: SyntheticEvent) => {
                setFieldValue('claimEstate.eventDate', date || null);
              }}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FieldLabel>Horário</FieldLabel>
            <Field
              value={values.claimEstate.eventTime || ''}
              component={Input}
              fluid
              type="time"
              onChange={(_e: any, { value }: { value: string }) =>
                setFieldValue('claimEstate.eventTime', value)
              }
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <FieldLabel>Descrição do Evento*</FieldLabel>
            <ReactQuill
              theme="snow"
              value={values.claimEstate.eventDescription || ''}
              modules={quillModules}
              onChange={(content: string) =>
                setFieldValue('claimEstate.eventDescription', content)
              }
              style={{ minHeight: 160, marginBottom: 40 }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default ClaimDetailsStep;
